export const FORTUNES = [
    "It's not a data swamp, it's a data lake with character.",
    'The pipeline is idempotent. The pipeline is idempotent. The pipeline is idempoten',
    'There are two hard problems in data: naming things, timezones, and off-by-one errors.',
    'dbt run succeeded. Nobody knows why.',
    'A BigQuery bill is just a love letter you write to Google every month.',
    'Schema-on-read is schema-on-someone-else’s-problem.',
    'The AI agent did it correctly on the 3rd try. We call this "engineering".',
    'Your DAG has a cycle. So does history.',
    'It works on my cluster.',
    'Real engineers test in prod. Great engineers have a rollback script.',
];

export const CAREER_LOG = [
    'f4b1e20 feat(tectoniq): co-found TectoniQ as Director of Technology',
    'c0ffee1 feat(cleanaway): tech lead & AI architect',
    'ba5e164 feat(bendigo-bank): tech lead',
    '9a77a0a feat: found Gamma Data — data platforms for the enterprise',
    'a5b2b4a feat(anz): enterprise-scale GCP implementation',
    'd00dbee chore: a decade of GCP, somehow',
    '1a17c0d feat: enter the IT industry (20 years ago)',
    '0000001 initial commit',
];

export const NEOFETCH_ART = [
    '████████╗ ██╗  ██╗',
    '╚══██╔══╝ ██║ ██╔╝',
    '   ██║    █████╔╝ ',
    '   ██║    ██╔═██╗ ',
    '   ██║    ██║  ██╗',
    '   ╚═╝    ╚═╝  ╚═╝',
];

export const NEOFETCH_INFO = [
    ['OS', 'TomOS 20.26 LTS'],
    ['Host', 'klimovski.io (Netlify free tier)'],
    ['Kernel', 'GCP-5.x-enterprise'],
    ['Uptime', '20 years in IT'],
    ['Shell', 'zsh (allegedly)'],
    ['Packages', 'dbt, BigQuery, Prefect, Vault, PowerBI, Claude Code'],
    ['Editor', "definitely-not-vim (try 'vim')"],
    ['Company', 'Gamma Data — gammadata.io'],
    ['Venture', 'TectoniQ — tectoniq.com.au (independent)'],
    ['Learning', 'how far AI coding agents can be pushed'],
];

export const PLAN_LINES = [
    'Building TIQ at TectoniQ.',
    'Shipping data platforms at Gamma Data.',
    'Teaching AI agents to behave.',
    "Back before the coffee's cold.",
];

export const SECRET_LINES = [
    'Okay, the actual secret:',
    "'do-not-run-me' is perfectly safe to run.",
    'Would I lie to you?',
];

export const BOOT_LINES = [
    'KLIMOVSKI BIOS v20.26 — (C) 2021-2026',
    'Memory check: 640K ........... OK (should be enough for anybody)',
    'Detecting coffee ............. OK',
    'Mounting ~ ................... OK',
    'Starting data pipelines ...... OK (3 retries)',
    'Negotiating with AI agents ... OK',
    'Starting shell ...',
];

export const MELTDOWN_LINES = [
    "rm: removing '/home/guest/about.txt'",
    "rm: removing '/home/guest/.plan'",
    "rm: removing '/home/guest/projects'",
    "rm: removing '/var/lib/dbt/models' (all 847 of them)",
    "rm: removing '/etc/gcp/credentials.json'",
    "rm: removing '/dev/coffee'",
    "rm: removing '/usr/share/twenty-years-of-experience'",
    "rm: removing '/opt/tectoniq/tiq'",
    "rm: removing 'node_modules' (17.3 GB freed)",
    "rm: removing '/boot/vmlinuz-tomos'",
    "rm: cannot remove '/sys/kernel/regret': Operation not permitted",
    "rm: removing '/'",
];
